<div class="searchbar-top job-view-top">
    <div class="student-testname">
      <h4>
        <div class="back-headingicon cursor-pointer d-flex" (click)="backButtoEvent()">
          <i class="fa-solid fa-arrow-left-long me-2"></i>
        </div>{{Title}}</h4>
    </div>
    <div class="top-group-wrap gap-2">
      <div class="input-group m-0">
        <input type="text" class="form-control" [(ngModel)]="enterSearch"  placeholder="Search...." aria-label="Search" aria-describedby="search-addon" 
        (keyup)="search($event)"/>
        <span class="input-group-text border-0" id="search-addon" >
          <i class="fas fa-search"></i>
        </span>
        <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
          <i class="fas fa-times"></i> 
       </span>
      </div>
      <div class="dropdown exportdropdown" *ngIf="exportButton">
        <a class="btn btn-primary common-button m-0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
          aria-expanded="false">
          <img src="../../../../assets/img/downloadicon.svg" alt="logo" class="img-fluid pe-2">
          <span>Export</span>
          <i class="fa-solid fa-angle-down ms-3"></i>      
        </a>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" (click)="ExportToExcel()"
              title="Export Excel">{{AppliedJobConstant.ExportDetails}}</a></li>
          <li><a class="dropdown-item" (click)="downloadPdf()" title="Export PDF">{{ AppliedJobConstant.ExportPdf }}</a></li>
        </ul>
      </div>
      <button type="button" class="btn btn-primary common-button m-0 icon-btn"(click)="refresh()"><i
        class="fa-solid fa-rotate-right"></i>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" aria-describedby="list">
        <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef> {{AppliedJobConstant.FULLNAME}} </th>
          <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="mobileNo">
          <th mat-header-cell *matHeaderCellDef> {{AppliedJobConstant.PHONE_NO}} </th>
          <td mat-cell *matCellDef="let element"> {{element.mobileNo}} </td>
        </ng-container>
        <ng-container matColumnDef="emailId">
          <th mat-header-cell *matHeaderCellDef> {{AppliedJobConstant.Email_ID}}</th>
          <td mat-cell *matCellDef="let element"> {{element.emailId}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="noticePeriod">
          <th mat-header-cell *matHeaderCellDef> {{AppliedJobConstant.NOTICE_PERIOD}} </th>
          <td mat-cell *matCellDef="let element"> {{element.noticePeriod}} Days </td>
        </ng-container>
        <ng-container matColumnDef="totalExperience">
          <th mat-header-cell *matHeaderCellDef> {{AppliedJobConstant.TOTAL_EXPERIENCE}}</th>
          <td mat-cell *matCellDef="let element"> {{element.totalExperience}} Years </td>
        </ng-container>
        <ng-container matColumnDef="resume">
          <th mat-header-cell *matHeaderCellDef>{{AppliedJobConstant.RESUME}} </th>
          <td mat-cell *matCellDef="let element">
            <a class="download-resume" (click)="DownloadResume(element.cv)">
              <img src="../../../../assets/img/download-docicon.svg" alt="pdf icon"
                class="img-fluid pe-2 download-docicon">
              <span>Download</span>
              <img src="../../../../assets/img/resume-downloadicn.svg" alt="download" class="img-fluid ps-2">
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action </th>
          <td mat-cell *matCellDef="let element">
            <div class="action-button-group">
              <a class="detailicon" title="View" (click)="AppliedJobDetail(element.jobApplyId)"><svg
                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-info-lg"
                  viewBox="0 0 16 16">
                  <path
                    d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
                </svg></a>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="showData" [ngClass]="dataSource.filteredData.length > 0 ? 'hidden' : 'visible'">
        <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoOneHasApplyYetFound}}</h5>
      </div>
    </div>
    <div class="mat-custom-table">
      <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
        [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
</div>